'use client';

import { Link } from '@mokoboko/components';

const showLabel = (hiddenCount: number) =>
  hiddenCount > 1 ? `Show ${hiddenCount} more` : 'Show more';

export const ShowMoreLink = ({
  expanded,
  hiddenCount,
  onToggle,
}: {
  expanded: boolean;
  hiddenCount: number;
  onToggle: () => void;
}) => (
  <Link
    role="button"
    tabIndex={0}
    size="sm"
    className="w-fit cursor-pointer"
    onClick={onToggle}
    onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onToggle();
      }
    }}
  >
    {expanded ? 'Hide all' : showLabel(hiddenCount)}
  </Link>
);
